export const isSesi = () => {
  const baseUrl = sessionStorage.getItem("baseUrl");
  return String(baseUrl).includes("sesi");
}